// MovieSkeleton Component - Loading skeleton for movie cards
import { Flex } from '../Flex';
import { Skeleton } from '../Skeleton';

const SIZES = {
  desktop: { imageWidth: 268, imageHeight: 447 },
  mobile: { imageWidth: 268, imageHeight: 320 },
};

interface MovieSkeletonProps {
  isMobile?: boolean;
}

export function MovieSkeleton({ isMobile = false }: MovieSkeletonProps) {
  const { imageWidth, imageHeight } = isMobile ? SIZES.mobile : SIZES.desktop;

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      className="movie-wrapper movie-skeleton"
    >
      <Skeleton width={imageWidth} height={imageHeight} />
      <Skeleton width={imageWidth} height="1.125rem" />
      <Skeleton width={imageWidth * 0.75} height="1.125rem" />
    </Flex>
  );
}
